<template>
  <div class="popup">
    <div
      v-if="visibility"
      @animationend="hidePopup"
      @click="hideOverlay"
      @touchmove.prevent
      :class="
        animationFadeOut
          ? 'animation-fade-out overlay animation-fade-in'
          : 'overlay animation-fade-in'
      "
    ></div>
    <div
      v-if="visibility"
      :class="
        contentOutAnimation
          ? 'animation-slide-out-down content animation-slide-in-up'
          : 'content animation-slide-in-up'
      "
    >
      <!-- 顶部标题部分 -->
      <div class="popup-title-bar">
        <div class="left">
          <span v-if="defaultList.singleTitle.title" class="single-title"
            ><img
              v-if="singleTitle.pic"
              class="pic"
              :src="singleTitle.pic"
              alt=""
            />{{ singleTitle.title }}</span
          >
          <span
            class="item"
            v-for="(item, index) in items"
            :key="index"
            @click="switchContent(index + 1, items.length - index)"
          >
            <i
              v-if="index != 0 && index != items.length"
              class="iconfont icon-arrowR"
            ></i>
            <img v-if="item.pic" class="pic" :src="item.pic" alt="" />
            <span
              :class="{
                text: true,
                link: !(
                  (items.length === 1 && index == 0) ||
                  (items.length > 1 && index === items.length - 1)
                ),
              }"
              >{{ item.text }}</span
            >
          </span>
        </div>
        <div class="right" @click="hideOverlay">
          <i class="close iconfont icon-guanbi"></i>
        </div>
      </div>
      <!-- 下方展示内容部分 -->
      <div class="popup-box">
        <div class="list" ref="scrollList">
          <div
            v-for="(item, index) in currentList"
            :key="index"
            @click="loadNext(item, items.length - 1)"
            class="list-item"
          >
            <span v-html="item.text"></span>
            <div class="icon"><i class="iconfont icon-arrowR"></i></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { mockTransData } from "@/store/mockdata";
import api from "@/apis/maintenance-api.js";
import validToken from "@/mixins/valid-token.js";
export default {
  mixins: [validToken],
  props: {
    // 初始化，获取一级列表（model_lists）的参数
    initParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 展示或隐藏（当前仅可用展示，隐藏在点击X时自动触发）
    vModel: {
      type: Boolean,
      default: false,
    },
    // 外部提供的数据，包含标题和内容（vin码识别和vin码搜索场景）
    defaultList: {
      type: Object,
      default: () => {
        return {
          internal_from: "",
          singleTitle: {
            title: "",
          },
          list: [],
        };
      },
    },
  },
  watch: {
    vModel(value) {
      if (
        value &&
        (this.initParams.brand_name || this.defaultList.singleTitle.title)
      ) {
        this.selectedInfo = Object.assign(this.selectedInfo, this.initParams);
        this.init();
      }
    },
  },

  data() {
    return {
      visibility: false,
      selectedInfo: {
        brand_name: "",
        model_name: "",
        factory_name: "",
        sales_name: "",
      },
      args: {},
      carInfo: "",
      animationFadeOut: false, //animation-fade-out
      contentOutAnimation: false, //animation-slide-out-down
      items: [],
      lists: [[], []],
      currentList: [],
      accessMenus: [],
      singleTitle: {},
      //vin码识别后，这块会有车型列表的5个筛选条件，车型仍不唯一的情况，需要id第二次筛选一下
      id: "", //车型id
    };
  },
  mounted() {
    this.accessMenus = JSON.parse(sessionStorage.getItem("valid_menus"));
  },
  methods: {
    scrollToTop() {
      this.$refs.scrollList.scrollTop = 0;
    },
    // 初始化，获取一级列表（model_lists）
    async init() {
      if (this.defaultList.singleTitle.title) {
        this.initByDefaultList();
        return;
      }
      const { logo, brand_name } = this.selectedInfo;
      this.$loading.show("加载中...");
      try {
        const res = await api.choosType({
          brand_name: brand_name,
        });
        if (res.code === 0) {
          this.items = [
            {
              pic: logo,
              text: brand_name,
            },
          ];
          let temp = res.data;
          temp.forEach((i) => (i.text = `${i.model_name}-${i.factory_name}`));
          this.lists[0] = temp;
          this.currentList = this.lists[0];
          this.$loading.hide();
          this.visibility = true;
        } else {
          this.$toast.show({
            showTime: 2,
            message: res.message,
            style: "error",
          });
        }
      } catch (error) {
        this.$loading.hide();
        console.log("获取models_list失败", error);
        this.$toast.show({
          showTime: 2,
          message: error,
          style: "error",
        });
      }
    },
    initByDefaultList() {
      this.singleTitle = this.defaultList.singleTitle;
      this.currentList = this.defaultList.list;
      this.visibility = true;
    },
    // 点击标题切换内容
    switchContent(index, length) {
      this.items.splice(index, length);
      this.currentList = this.lists[index - 1];
    },
    // 点击内容列表请求下级内容
    // item-列表对象 index-当前是几级列表
    loadNext(item, index) {
      this.scrollToTop();
      console.log(item, index);
      switch (index + 1) {
        case 0: //车型列表 from vin 、 点击车型后的车型备注列表、额外选项列表、
          this.loadOtherList1(item);
          break;
        case 1: //models_list
          this.loadSalesNameList(item);
          break;
        case 2: //sales_name_list
          this.loadProductYearList(item);
          break;
        case 3: //product_year_list
          // 加载机油-发动机或车型备注、加载箱油-额外选项、加载轮胎-额外选项
          this.loadOtherList1(item);
          break;
        case 4: // engines_list/notes_list
          // 加载机油-车型备注或点击发动机列表直接跳转/点击机油-车型备注直接跳转/点击箱油或轮胎额外选项直接跳转
          this.loadOtherList2(item);
          break;
        case 5: // notes_list
          // 点击机油-车型备注直接跳转
          this.toNext(item);
          break;
      }
    },
    async loadSalesNameList(item) {
      this.selectedInfo.model_name = item.model_name;
      this.selectedInfo.factory_name = item.factory_name;
      const { brand_name, model_name, factory_name } = this.selectedInfo;
      const params = {
        brand_name,
        model_name,
        factory_name,
      };
      try {
        this.$loading.show("加载中");
        const res = await api.chooseDisplacement(params);
        if (res.code === 0) {
          this.items.push({
            text: `${model_name}-${factory_name}`,
          });
          res.data.forEach((i) => (i.text = i.sales_name));
          this.lists[1] = res.data;
          this.currentList = this.lists[1];
        } else {
          this.$toast.show({
            showTime: 2,
            message: res.message,
            style: "error",
          });
        }
        this.$loading.hide();
      } catch (error) {
        console.log(error);
        this.$loading.hide();
      }
    },
    async loadProductYearList(item) {
      this.selectedInfo.sales_name = item.sales_name;
      const { brand_name, model_name, factory_name, sales_name } =
        this.selectedInfo;
      const params = { brand_name, model_name, factory_name, sales_name };
      try {
        this.$loading.show("加载中");
        const res = await api.chooseYear(params);
        if (res.code === 0) {
          this.items.push({
            text: sales_name,
          });
          res.data.forEach((i) => (i.text = i.release_year));
          this.lists[2] = res.data;
          this.currentList = this.lists[2];
        } else {
          this.$toast.show({
            showTime: 2,
            message: res.message,
            style: "error",
          });
        }
        this.$loading.hide();
      } catch (error) {
        console.log(error);
        this.$loading.hide();
      }
    },
    toBrakingSystem(item) {
      this.$router.push({
        path: "maintenance-detail",
        query: {
          vehicle_id: item.vehicle_id,
          menu_type: 5,
          scheme_id: this.$route.query.scheme_id,
          internal_from: this.defaultList.internal_from,
        },
      });
    },
    loadOtherList1(item) {
      this.selectedInfo.release_year = item.release_year;
      this.saveArgs(item);
      // 授权菜单大于一个的情况。后续判断在此页面处理
      const valid_menus = JSON.parse(sessionStorage.getItem("valid_menus"));
      if (valid_menus.length >= 1) {
        switch (valid_menus[0].type) {
          case 1:
            this.loadEnginesList(item);
            break;
          case 2:
            this.loadTransExtraOptions(item);
            break;
          case 3:
            this.loadTireExtraOptions(item);
            break;
          case 4:
            this.loadOilFilterOptions(item);
            break;
          case 5:
            this.toBrakingSystem(item);
            break;
          default:
            break;
        }
        // 授权菜单大于1个的情况，后续判断在中间页面
      }
      // else if (this.accessMenus.length > 1) {
      //   let from = this.defaultList.singleTitle.title ? "vin" : "select";
      //   this.$router.push({
      //     name: "category-select",
      //     query: {
      //       from,
      //       id: item.id ? item.id : "", //汽车id
      //       scheme_id:
      //         this.$route.query.scheme_id || this.$route.query.id || "", //版本id
      //       ...this.args,
      //       internal_from: this.defaultList.internal_from,
      //     },
      //   });
      // }
      // TODO 待修改
      else {
        this.$router.push({
          path: "maintenance-detail",
          query: {
            vehicle_ids: item.id ? encodeURIComponent(item.id.join(",")) : "",
            vehicle_id: item.id,
            menu_type: 0,
            scheme_id: this.$route.query.scheme_id,
            internal_from: this.defaultList.internal_from,
          },
        });
      }
    },

    // 加载机油-发动机列表/车型备注列表
    async loadEnginesList(item) {
      // vin码识别后的车型列表跳转
      if (this.defaultList.singleTitle.title) {
        // 车型备注直接跳转
        if (item.memo_val) {
          this.$router.push({
            path: "maintenance-detail",
            query: {
              scheme_id: this.$route.query.scheme_id || this.$route.query.id,
              menu_type: 1,
              viscosity_type: item.type,
              vehicle_id: item.vehicle_id,
              internal_from: this.defaultList.internal_from,
            },
          });
          // this.$router.push({
          //   path: "/detail",
          //   query: {
          //     menu: 1,
          //     levelId: item.vehicle_id,
          //     value: item.type,
          //     isVin: 1,
          //     scheme_id: this.$route.query.scheme_id || this.$route.query.id,
          //     internal_from: this.defaultList.internal_from,
          //   },
          // });
        } else {
          // 解析出车型备注或没有车型备注直接跳转
          this.parseNotesList(item);
        }
        return;
      }
      this.selectedInfo.release_year = item.release_year;
      const { brand_name, model_name, factory_name, sales_name, release_year } =
        this.selectedInfo;

      try {
        await this.fetchValidToken();
        const scheme_id = this.$route.query.scheme_id || this.$route.query.id;
        const params = {
          brand_name,
          model_name,
          factory_name,
          sales_name,
          release_year,
          parts_type: 1,
          token: this.token,
          scheme_id,
        };
        if (!this.token) return;
        this.$loading.show("加载中");
        const res = await api.getModelDetail(params);
        if (res.code === 0) {
          this.carInfo = res.data;
          if (!res.data.is_vin_get && res.data.engine_models.length >= 1) {
            this.items.push({
              text: `${release_year}`,
            });
            res.data.engine_models.forEach((i) => (i.text = i.engine_model));
            this.lists[3] = res.data.engine_models;
            this.currentList = this.lists[3];
          } else if (res.data.engine_models.length === 0) {
            if (
              res.data.vehicle_list[0] &&
              res.data.vehicle_list[0].memo_list.length > 0
            ) {
              this.items.push({
                text: `${release_year}`,
              });
              res.data.vehicle_list[0].memo_list.forEach(
                (i) => (i.text = i.memo_val)
              );
              this.lists[3] = res.data.vehicle_list[0].memo_list;
              this.currentList = this.lists[3];
            } else {
              this.$router.push({
                path: "/detail",
                query: {
                  menu: 1,
                  levelId: res.data.vehicle_list[0].id,
                  value: 1,
                  scheme_id:
                    this.$route.query.scheme_id || this.$route.query.id,
                  internal_from: this.defaultList.internal_from,
                },
              });
            }
          }
        } else {
          this.$toast.show({
            showTime: 2,
            message: res.message,
            style: "error",
          });
        }
        this.$loading.hide();
      } catch (error) {
        this.$loading.hide();
        console.log(error);
      }
    },
    // 加载机油-车型备注/点击机油-车型备注直接跳转
    loadOtherList2(item) {
      // 车型备注直接跳转
      if (item.memo_val) {
        this.$router.push({
          path: "/detail",
          query: {
            menu: 1,
            levelId: item.vehicle_id,
            value: item.type,
            scheme_id: this.$route.query.scheme_id || this.$route.query.id,
            isVin: this.defaultList.singleTitle.title ? 1 : "",
            internal_from: this.defaultList.internal_from,
          },
        });
        return;
      }
      // 从变速箱油-额外选项跳转过来的
      if (item.key && this.accessMenus[0].type == 2) {
        this.$router.push({
          path: "/detail",
          query: {
            menu: 2,
            key: item.key,
            scheme_id: this.$route.query.scheme_id || this.$route.query.id,
            ...this.args,
            internal_from: this.defaultList.internal_from,
          },
        });
        return;
      }
      // 从轮胎-额外选项跳转过来的
      if (item.key && this.accessMenus[0].type == 3) {
        this.$router.push({
          path: "/detail",
          query: {
            menu: 3,
            key: item.key,
            scheme_id: this.$route.query.scheme_id || this.$route.query.id,
            ...this.args,
            internal_from: this.defaultList.internal_from,
          },
        });
        return;
      }
      // 加载机油-车型备注
      this.selectedInfo.vehicle_id = item.vehicle_id;
      const { vehicle_id } = this.selectedInfo;
      let car = this.carInfo.vehicle_list.find((i) => {
        return i.id == vehicle_id;
      });
      // mock
      // car.memo_list = [
      //   {
      //     type: 1,
      //     memo_id: 4250,
      //     memo_val: "机油盖无标识",
      //     oil_grade: "5W-40",
      //     vehicle_id: 193435,
      //   },
      //   {
      //     type: 2,
      //     memo_id: 4249,
      //     memo_val: "机油盖有标识0W-20",
      //     oil_grade: "0W-20",
      //     vehicle_id: 193435,
      //   },
      // ];
      if (car.memo_list.length > 0) {
        this.items.push({
          text: `发动机-${item.text}`,
        });
        car.memo_list.forEach((i) => (i.text = i.memo_val));
        this.lists[4] = car.memo_list;
        this.currentList = this.lists[4];
      } else {
        this.$router.push({
          path: "/detail",
          query: {
            menu: 1,
            levelId: car.id,
            value: 1,
            scheme_id: this.$route.query.scheme_id || this.$route.query.id,
            internal_from: this.defaultList.internal_from,
          },
        });
      }
    },
    toNext(item) {
      this.$router.push({
        path: "/detail",
        query: {
          menu: 1,
          levelId: item.vehicle_id,
          value: item.type,
          isVin: this.defaultList.singleTitle.title ? 1 : "",
          scheme_id: this.$route.query.scheme_id || this.$route.query.id,
          internal_from: this.defaultList.internal_from,
        },
      });
    },
    // 加载变速箱油-额外选项 /点击变速箱油-额外选项直接跳转
    async loadTransExtraOptions(item) {
      if (item.id) {
        this.id = item.id;
      }
      console.log(2333, this.id);
      // 如果存在key，则点击了额外选项
      if (item.key) {
        this.$router.push({
          path: "/maintenance-detail",
          query: {
            menu_type: 2,
            key: item.key,
            scheme_id: this.$route.query.scheme_id || this.$route.query.id,
            vehicle_ids: this.id ? encodeURIComponent([this.id].join(",")) : "",
            internal_from: this.defaultList.internal_from,
          },
        });
        // this.$router.push({
        //   path: "/detail",
        //   query: {
        //     menu: 2,
        //     key: item.key,
        //     ...this.args,
        //     scheme_id: this.$route.query.scheme_id || this.$route.query.id,
        //     id: this.id ? this.id : "",
        //     internal_from: this.defaultList.internal_from,
        //   },
        // });
        return;
      }
      const { id, release_year } = this.selectedInfo;
      let vehicle_ids = id ? [id] : [];
      await this.fetchValidToken();
      const scheme_id = this.$route.query.scheme_id || this.$route.query.id;
      const params = {
        ...this.args,
        parts_type: 2,
        vehicle_ids,
        token: this.token,
        scheme_id,
      };
      if (!this.token) return;
      this.$loading.show("加载中...");
      try {
        const res = await api.getModelDetail(params);
        if (res.code === 0) {
          // res.data = mockTransData;
          if (res.data.datum_list.length > 1) {
            res.data.datum_list.forEach((i) => (i.text = i.choices[0].value));
            let tempChoices = res.data.datum_list.map((i) => {
              return { choices: i.choices, key: i.key };
            });
            tempChoices.forEach((i) => {
              i.text = i.choices.reduce(
                (res, cur) =>
                  `${res}${res ? "<br>" : ""}${
                    cur.name
                  }: <span style="color:#333">${cur.value}</span>`,
                ""
              );
              i.multiple = i.text.length > 8 ? true : false;
            });
            if (this.defaultList.singleTitle.title) {
              this.singleTitle = {
                title: "额外选项",
                pic: "",
              };
              this.currentList = tempChoices;
            } else {
              this.items.push({
                text: `${release_year}`,
              });
              this.lists[3] = tempChoices;
              this.currentList = this.lists[3];
            }
          } else {
            this.$router.push({
              path: "/maintenance-detail",
              query: {
                menu_type: 2,
                key: res.data.parts_list[0] ? res.data.parts_list[0].key : "",
                scheme_id: this.$route.query.scheme_id || this.$route.query.id,
                vehicle_ids: this.id
                  ? encodeURIComponent([this.id].join(","))
                  : "",
                internal_from: this.defaultList.internal_from,
              },
            });
            // this.$router.push({
            //   path: "/detail",
            //   query: {
            //     menu: 2,
            //     key: res.data.parts_list[0] ? res.data.parts_list[0].key : "",
            //     ...this.args,
            //     scheme_id: this.$route.query.scheme_id || this.$route.query.id,
            //     id: this.id ? this.id : "",
            //     internal_from: this.defaultList.internal_from,
            //   },
            // });
          }
        } else {
          this.$toast.show({
            showTime: 3,
            message: res.message,
            style: "error",
          });
        }
      } catch (error) {
        console.log(error);
        this.$loading.hide();
      }
      this.$loading.hide();
    },
    async loadOilFilterOptions(item) {
      if (item.id) {
        this.id = item.id;
      }
      // 点击滤清器备注后的逻辑
      if (item.key) {
        this.$router.push({
          path: "/maintenance-detail",
          query: {
            menu_type: 4,
            key: item.key,
            scheme_id: this.$route.query.scheme_id || this.$route.query.id,
            vehicle_ids: this.id ? encodeURIComponent([this.id].join(",")) : "",
            internal_from: this.defaultList.internal_from,
          },
        });
        // this.$router.push({
        //   path: "/detail",
        //   query: {
        //     menu: 4,
        //     key: item.key,
        //     ...this.args,
        //     scheme_id: this.$route.query.scheme_id || this.$route.query.id,
        //     id: this.id ? this.id : "",
        //     internal_from: this.defaultList.internal_from,
        //   },
        // });
        return;
      }
      await this.fetchValidToken();
      if (!this.token) return;
      // 只有一个滤清器时，获取滤清器备注并直接跳转详情
      this.$loading.show("加载中...");
      try {
        let vehicle_ids = this.id ? [this.id] : [];
        const scheme_id = this.$route.query.scheme_id || this.$route.query.id;
        const params = {
          ...this.args,
          parts_type: 4,
          vehicle_ids,
          token: this.token,
          scheme_id,
        };
        const res = await api.getModelDetail(params);
        if (res.code === 0) {
          if (res.data.parts_list.length > 1) {
            this.currentList = res.data.parts_list.map((i) => {
              i.text = i.choices[0].value;
              return i;
            });
          } else if (res.data.parts_list.length === 1) {
            this.$router.push({
              path: "/maintenance-detail",
              query: {
                menu_type: 4,
                key: res.data.parts_list[0].key,
                scheme_id: this.$route.query.scheme_id || this.$route.query.id,
                vehicle_ids: this.id
                  ? encodeURIComponent([this.id].join(","))
                  : "",
                internal_from: this.defaultList.internal_from,
              },
            });
            // this.$router.push({
            //   path: "/detail",
            //   query: {
            //     menu: 4,
            //     key: res.data.parts_list[0].key,
            //     ...this.args,
            //     scheme_id: this.$route.query.scheme_id || this.$route.query.id,
            //     id: this.id ? this.id : "",
            //     internal_from: this.defaultList.internal_from,
            //   },
            // });
          } else if (res.data.parts_list.length === 0) {
            this.$loading.hide();
            this.$router.push({
              path: "/maintenance-detail",
              query: {
                menu_type: 4,
                key: "",
                scheme_id: this.$route.query.scheme_id || this.$route.query.id,
                vehicle_ids: this.id
                  ? encodeURIComponent([this.id].join(","))
                  : "",
                internal_from: this.defaultList.internal_from,
              },
            });
            // this.$router.push({
            //   path: "/detail",
            //   query: {
            //     menu: 4,
            //     key: "",
            //     ...this.args,
            //     scheme_id: this.$route.query.scheme_id || this.$route.query.id,
            //     id: this.id ? this.id : "",
            //     internal_from: this.defaultList.internal_from,
            //   },
            // });
            // this.$toast.show({
            //   showTime: 3,
            //   message: "当前仅开放滤清器菜单，且当前车型无滤清器数据！",
            //   style: "error",
            // });
            return;
          }
        } else {
          this.$toast.show({
            showTime: 3,
            message: res.message,
            style: "error",
          });
        }
      } catch (error) {
        console.log("获取滤清器备注信息失败", error);
        this.$loading.hide();
      }
      this.$loading.hide();
    },
    // 加载轮胎-额外选项 / 点击 轮胎-额外选项
    async loadTireExtraOptions(item) {
      if (item.id) {
        this.id = item.id;
      }
      console.log(2333, this.id);
      // 如果存在key，则点击了额外选项
      if (item.key) {
        this.$router.push({
          path: "/maintenance-detail",
          query: {
            menu_type: 3,
            key: item.key,
            scheme_id: this.$route.query.scheme_id || this.$route.query.id,
            vehicle_ids: this.id ? encodeURIComponent([this.id].join(",")) : "",
            internal_from: this.defaultList.internal_from,
          },
        });
        // this.$router.push({
        //   path: "/detail",
        //   query: {
        //     menu: 3,
        //     key: item.key,
        //     ...this.args,
        //     scheme_id: this.$route.query.scheme_id || this.$route.query.id,
        //     id: this.id ? this.id : "",
        //     internal_from: this.defaultList.internal_from,
        //   },
        // });
        return;
      }
      const { release_year } = this.selectedInfo;
      await this.fetchValidToken();
      const scheme_id = this.$route.query.scheme_id || this.$route.query.id;
      const params = {
        ...this.args,
        parts_type: 3,
        token: this.token,
        scheme_id,
      };
      if (!this.token) return;
      this.$loading.show("加载中...");
      try {
        const res = await api.getModelDetail(params);
        if (res.code === 0) {
          // mock
          // res.data = mockTransData;
          if (res.data.parts_list.length > 1) {
            res.data.parts_list.forEach((i) => (i.text = i.choices[0].value));
            let tempChoices = res.data.parts_list.map((i) => {
              return { choices: i.choices, key: i.key };
            });
            tempChoices.forEach((i) => {
              i.text = i.choices.reduce(
                (res, cur) =>
                  `${res}${res ? "<br>" : ""}${
                    cur.name
                  }: <span style="color:#333">${cur.value}</span>`,
                ""
              );
              i.multiple = i.text.length > 8 ? true : false;
            });
            if (this.defaultList.singleTitle.title) {
              this.singleTitle = {
                title: "额外选项",
                pic: "",
              };
              this.currentList = tempChoices;
            } else {
              this.items.push({
                text: `${release_year}`,
              });
              this.lists[3] = tempChoices;
              this.currentList = this.lists[3];
            }
            // 没有直接跳转
          } else {
            this.$router.push({
              path: "/maintenance-detail",
              query: {
                menu_type: 3,
                key: res.data.parts_list[0] ? res.data.parts_list[0].key : "",
                scheme_id: this.$route.query.scheme_id || this.$route.query.id,
                vehicle_ids: this.id
                  ? encodeURIComponent([this.id].join(","))
                  : "",
                internal_from: this.defaultList.internal_from,
              },
            });
            // this.$router.push({
            //   path: "/detail",
            //   query: {
            //     menu: 3,
            //     key: res.data.parts_list[0] ? res.data.parts_list[0].key : "",
            //     ...this.args,
            //     scheme_id: this.$route.query.scheme_id || this.$route.query.id,
            //     id: this.id ? this.id : "",
            //     internal_from: this.defaultList.internal_from,
            //   },
            // });
          }
        } else {
          this.$toast.show({
            showTime: 3,
            message: res.message,
            style: "error",
          });
        }
      } catch (error) {
        console.log(error);
        this.$loading.hide();
      }
      this.$loading.hide();
    },
    parseNotesList(item) {
      if (item.memo_list.length > 0) {
        this.singleTitle = {
          title: "请选择车型备注",
          pic: "",
        };
        item.memo_list.forEach((i) => (i.text = i.memo_val));
        this.currentList = item.memo_list;
      } else {
        this.$router.push({
          path: "/maintenance-detail",
          query: {
            menu_type: 1,
            vehicle_id: item.id,
            viscosity_type: 1,
            scheme_id: this.$route.query.scheme_id || this.$route.query.id,
            internal_from: this.defaultList.internal_from,
          },
        });
        // this.$router.push({
        //   path: "/detail",
        //   query: {
        //     menu: 1,
        //     levelId: item.id,
        //     isVin: 1,
        //     value: 1,
        //     scheme_id: this.$route.query.scheme_id || this.$route.query.id,
        //     internal_from: this.defaultList.internal_from,
        //   },
        // });
      }
    },
    saveArgs(item) {
      if (item.key) return; //点击的是额外选项列表，则无需更新args
      // 有item是vin码识别传入的品牌信息，默认是手动选择的品牌信息
      const {
        brand_name,
        factory_name,
        model_alias,
        release_year,
        displacement,
        sales_name,
      } = item ? item : this.selectedInfo;
      this.args = {
        brand_name,
        factory_name,
        model_alias,
        release_year,
        displacement,
        sales_name,
      };
    },
    hideOverlay() {
      this.animationFadeOut = true;
      this.contentOutAnimation = true;
    },
    hidePopup() {
      if (!this.animationFadeOut) return;
      this.animationFadeOut = false;
      this.contentOutAnimation = false;
      this.visibility = false;
      // 必要参数置空
      this.items = [];
      this.lists = [[], []];
      this.currentList = [];
      this.singleTitle = {};
      this.id = "";
      this.$emit("close", false);
    },
  },
};
</script>
<style lang="less" scoped>
.popup {
  display: fixed;
  .overlay {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 19;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
  }
}
.link {
  color: #c72d2d;
}
.content {
  position: fixed;
  background-color: #fff;
  z-index: 20;
  height: 693/100rem;
  width: 100%;
  left: 0;
  bottom: 0;
  padding: 0 20/100rem;
  display: flex;
  flex-direction: column;
  .popup-title-bar::after {
    content: " ";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    transform: scaleY(0.5);
    background-color: #ddd;
  }
  .popup-title-bar {
    display: flex;
    flex-shrink: 0;
    justify-content: space-between;
    padding: 20/100rem 0;
    // min-height: 40/100rem;
    height: auto;
    align-items: center;
    position: relative;
    .left {
      // min-height: 40/100rem;
      margin-top: 10/100rem;
      display: flex;
      flex-wrap: wrap;
      .single-title {
        flex-shrink: 0;
        font-size: 24/100rem;
        img {
          width: 26/100rem;
          height: 26/100rem;
          margin-right: 10/100rem;
        }
        span {
          font-size: 24/100rem;
        }
      }
      .item {
        height: auto;
        display: flex;
        align-items: center;
        color: #6a6a6a;
        flex-shrink: 0;
        i {
          font-size: 10px;
          color: #ccc;
          margin: 0 15/100rem;
        }
        img {
          width: 26/100rem;
          height: 26/100rem;
          margin-right: 10/100rem;
        }
        span {
          font-size: 24/100rem;
        }
      }
    }
    .right {
      width: 20/100rem;
      margin-left: 20/100rem;
      i {
        font-size: 22/100rem;
        color: #ccc;
      }
    }
  }
  .popup-box {
    .list {
      height: 623/100rem;
      overflow: auto;
      .list-item::after {
        content: " ";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        transform: scaleY(0.5);
        background-color: #ddd;
      }
      .list-item:active {
        background: #f9fafb;
      }
      .list-item {
        display: flex;
        position: relative;
        justify-content: space-between;
        min-height: 88/100rem;
        box-sizing: border-box;
        align-items: center;
        color: #404040;
        font-size: 27/100rem;
        .icon {
          height: 100%;
          display: flex;
          align-items: center;
          i {
            font-size: 10px;
            color: #ccc;
          }
        }
        span {
          margin: 26/100rem 0;
        }
      }
    }
  }
}
[class*="animation-"] {
  animation-timing-function: ease-out;
  animation-fill-mode: both;
}
.animation-fade-in {
  animation-duration: 0.2s;
  animation-name: fade-in;
}
.animation-fade-out {
  animation-duration: 0.2s;
  animation-name: fade-out;
}
.animation-slide-in-up {
  animation-duration: 0.2s;
  animation-name: slide-in-up;
}
.animation-slide-out-down {
  animation-duration: 0.2s;
  animation-name: slide-out-down;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
@keyframes fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes slide-in-up {
  0% {
    transform: translate3d(0, 100%, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes slide-out-down {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(0, 100%, 0);
  }
}
</style>
